import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Icon from '../../common/Icons';
import { AdminPersonnelPageHeader } from '../ui';
import { AP_PATHS } from '../adminPersonnelPaths';
import { AP_COPY } from '../adminPersonnelCopy';
import '../AdminPersonnelPortal.css';

const PLACEHOLDERS = {
  profile: {
    title: AP_COPY.PLACEHOLDER.PROFILE_TITLE,
    description: AP_COPY.PLACEHOLDER.PROFILE_DESC,
    icon: 'user'
  },
  settings: {
    title: AP_COPY.PLACEHOLDER.SETTINGS_TITLE,
    description: AP_COPY.PLACEHOLDER.SETTINGS_DESC,
    icon: 'cog'
  },
  reports: {
    title: AP_COPY.PLACEHOLDER.REPORTS_TITLE,
    description: AP_COPY.PLACEHOLDER.REPORTS_DESC,
    icon: 'chartBar'
  },
  activities: {
    title: AP_COPY.PLACEHOLDER.ACTIVITIES_TITLE,
    description: AP_COPY.PLACEHOLDER.ACTIVITIES_DESC,
    icon: 'history'
  },
  notifications: {
    title: AP_COPY.PLACEHOLDER.NOTIFICATIONS_TITLE,
    description: AP_COPY.PLACEHOLDER.NOTIFICATIONS_DESC,
    icon: 'bell'
  }
};

export default function AdminPersonnelPlaceholderPage({ placeholderKey = 'reports' }) {
  const navigate = useNavigate();
  const content = PLACEHOLDERS[placeholderKey] || PLACEHOLDERS.reports;

  return (
    <div className="ap-dash">
      <AdminPersonnelPageHeader
        badge={AP_COPY.DASHBOARD.BADGE}
        title={content.title}
        description={content.description}
      />
      <div className="ap-panel ap-placeholder">
        <div className="ap-placeholder__icon" aria-hidden>
          <Icon name={content.icon} size={40} />
        </div>
        <p className="text-muted mb-4" style={{ maxWidth: '28rem' }}>
          {content.description}
        </p>
        <Button variant="primary" className="rounded-3" onClick={() => navigate(AP_PATHS.DASHBOARD)}>
          {AP_COPY.PLACEHOLDER_BACK}
        </Button>
      </div>
    </div>
  );
}
